const Dashboard = () => import('@/views/Dashboard');
const Support = () => import('@/views/Support');

export default [
	{
		path: '/dashboard',
		name: 'dashboard',
		component: Dashboard,
		meta: {
			title: 'Panel',
			layout: 'layout',
			requiresAuth: true,
			isSuperUser: true,
		},
	},
	{
		path: '/support',
		name: 'support',
		component: Support,
		meta: { title: 'Soporte', layout: 'layout', requiresAuth: true, isSuperUser: true },
	},
];
